/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-wl-electronic-signature-purpose-popup',
  templateUrl: './wl-electronic-signature-purpose-popup.component.html'
})
export class WlElectronicSignaturePurposePopupComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  personalDataConsent

  ngOnInit(): void {
  }

}
